<template>
  <div class="app-shell">
    <aside class="app-sidebar" :class="{ 'is-open': sidebarOpen }">
      <div class="app-sidebar__brand">
        <img src="@/assets/logo-branca.png" alt="LC3 Market" class="app-sidebar__logo">
      </div>
      <Navbar/>
    </aside>
    <div v-if="sidebarOpen" class="app-sidebar-backdrop" @click="sidebarOpen = false"></div>
    <div class="app-main">
      <header class="app-topbar">
        <div class="app-topbar__heading">
          <button type="button" class="app-hamburger" @click="sidebarOpen = !sidebarOpen" title="Menu" aria-label="Abrir menu">
            <i class="bi bi-list"></i>
          </button>
          <router-link v-if="backTo" :to="{ name: backTo }" class="app-back-btn" title="Voltar">
            <i class="bi bi-arrow-left"></i>
          </router-link>
          <h1>{{ title }}</h1>
        </div>
        <div class="app-topbar__actions">
          <slot name="actions"/>
        </div>
      </header>
      <main class="app-content">
        <slot/>
      </main>
    </div>
  </div>
</template>
<script>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import Navbar from './Navbar.vue';

export default {
  name: 'AppLayout',
  components: {
    Navbar
  },
  props: {
    title: { type: String, default: '' },
    // Nome da rota para o botão de voltar no cabeçalho (páginas de detalhe).
    backTo: { type: String, default: null },
  },
  setup() {
    const sidebarOpen = ref(false);
    const route = useRoute();

    // Fecha o menu ao navegar (link do menu ou botão de voltar) — só tem
    // efeito no mobile, onde o sidebar fica fora da tela por padrão.
    watch(() => route.fullPath, () => {
      sidebarOpen.value = false;
    });

    return { sidebarOpen };
  },
}
</script>
<style scoped>
.app-shell {
  display: flex;
  align-items: flex-start;
  min-height: 100vh;
}

.app-sidebar {
  width: 240px;
  flex-shrink: 0;
  background: var(--sidebar-bg);
  padding: 1.5rem 1rem;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
}

.app-sidebar__brand {
  padding: 0 0.5rem;
  margin-bottom: 1.5rem;
}

.app-sidebar__logo {
  width: 100%;
}

.app-main {
  flex: 1;
  min-width: 0;
}

.app-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: var(--surface);
  border-bottom: 1px solid var(--border-color);
}

.app-topbar__heading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.app-hamburger {
  display: none;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border: none;
  border-radius: 50%;
  background: var(--surface-muted);
  color: var(--text-strong);
  font-size: 1.25rem;
  flex-shrink: 0;
}

.app-sidebar-backdrop {
  display: none;
}

.app-topbar__heading h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-strong);
}

.app-back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  background: var(--surface-muted);
  color: var(--text);
  text-decoration: none;
  transition: background 0.15s ease;
}

.app-back-btn:hover {
  background: var(--border-color);
  color: var(--text-strong);
}

.app-content {
  padding: 2rem;
}

@media (max-width: 768px) {
  .app-shell {
    display: block;
    min-height: 100vh;
  }

  .app-hamburger {
    display: inline-flex;
  }

  .app-sidebar {
    position: fixed;
    z-index: 1050;
    width: 260px;
    max-width: 80vw;
    transform: translateX(-100%);
    transition: transform 0.2s ease;
    box-shadow: var(--shadow-md);
  }

  .app-sidebar.is-open {
    transform: translateX(0);
  }

  .app-sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 1040;
    background: rgba(0, 0, 0, 0.4);
  }

  .app-main {
    width: 100%;
  }

  .app-topbar,
  .app-content {
    padding: 1.25rem;
  }
}
</style>
